// extracted by mini-css-extract-plugin
module.exports = {"good-id-custom-styles":"_1SKBAmZn","goodIdCustomStyles":"_1SKBAmZn"};